import { Component, Input, OnInit } from '@angular/core';
import { MiscUtil } from '../../../util/misc.util';

import { DATAID } from '../../../services/data.service';

import { inject } from '@angular/core';

import { LibModulesWolcModule } from '../../../components/lib-modules-wolc.module';
import { BooktechAppService } from "../../../services/booktech-app.service";


@Component({
    selector: 'bt-page-wrapper',
    imports: [LibModulesWolcModule],
    templateUrl: './page-wrapper.component.html',
    styleUrl: './page-wrapper.component.scss'
})
export class PageWrapperComponent {
  bas = inject(BooktechAppService);


  @Input() showOperatingMessages:boolean = true;


  operatingMessages:any = "";
  
  constructor() {
  
    this.bas.ds.find(DATAID.APP_WEB_OPERATING_MESSAGES).subscribe((oms:any) => {
      let diff = (new Date().getTime() - (oms.time || new Date().getTime() ) ) / 1000;
      if(this.bas.envtest) console.log("APP_WEB_OPERATING_MESSAGES, diff: " + diff, ": ", oms);
      let message =  ((oms.updateTime || " ") + (oms.message || "")).trim();
      this.operatingMessages = this.showOperatingMessages && diff < 60 * 60 ? message : "";  // 1 hour

      if (oms.updateTimeExpireDiff && !oms.message) {
        setTimeout(() => {
          if(this.bas.envtest) console.log("Remving message, oms: ", oms);
          this.operatingMessages = "";
        }, oms.updateTimeExpireDiff * 1000);
      }
    })
    
  }

  ngOnInit(): void {

  }


}




